import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import "../styles/FavoritePage.css";
import { PiListMagnifyingGlass } from "react-icons/pi";
import { getBookLater, removeBookLater } from "../config/firebaseService";
import { AuthContext } from "../components/AuthContext";

const FavoritePage = () => {
  //state to store list of favourite movies
  const [favoriteMovies, setFavoriteMovies] = useState([]);
  const { user } = useContext(AuthContext);

  // Load movies from Firestore for the logged-in user
  useEffect(() => {
    const load = async () => {
      if (!user?.id) return;
      try {
        const items = await getBookLater(user.id);
        setFavoriteMovies(items);
      } catch (e) {
        console.warn("Failed to load Book Later from Firestore", e);
      }
    };
    load();
  }, [user]);

  //function to remove a movie from favourites
  const removeFavorite = async (id) => {
    //filter out movies to be removed
    const updatedFavorites = favoriteMovies.filter((movie) => String(movie.id) !== String(id));
    setFavoriteMovies(updatedFavorites);
    if (user?.id) {
      try { await removeBookLater(user.id, id); } catch (e) { console.warn("Failed to remove from Firestore", e); }
    }
  };

  return (
  <main className="favorites-container">

      {favoriteMovies.length === 0 ? (
        <section className="empty-state" aria-labelledby="empty-fav-title">
          <figure className="empty-icon" aria-hidden>
            <PiListMagnifyingGlass />
          </figure>
          <h2 id="empty-fav-title">Nothing saved for later</h2>
          <p>Add movies to your list to book them when it suits you.</p>
          <Link to="/" className="btn primary">Discover movies</Link>
        </section>
      ) : (
  <ul className="movies-grid-2">
          {favoriteMovies.map((movie) => (
            <li key={movie.id}>
              <article className="movie-card-2">
                <figure>
                  <img
                    src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                    alt={movie.title}
                    className="movie-poster-2"
                    loading="lazy"
                    decoding="async"
                  />
                  <figcaption className="visually-hidden">{movie.title}</figcaption>
                </figure>
                <footer className="movie-actions" aria-label="Movie actions">
                  <button className="remove-movie-btn" onClick={() => removeFavorite(movie.id)} aria-label={`Remove ${movie.title} from saved list`}>
                    Remove
                  </button>
                  <Link to={`/movie/${movie.id}`} className="book-now-btn">
                    Book now
                  </Link>
                </footer>
              </article>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
};

export default FavoritePage;
